module.exports = __webpack_public_path__ + "static/media/28DGC4.ef17f0d2.jpg";